import { Hexagon } from "@phosphor-icons/react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const resolveLogoUrl = (url) => {
  if (!url) return "";
  // Relative paths like "/api/static/logo.png" → prepend backend URL
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
};

const proxyAsset = (url) => {
  if (!url) return "";
  const resolved = resolveLogoUrl(url);
  // Same-origin (relative /api/*) → use directly, no proxy needed
  if (resolved.startsWith(BACKEND_URL)) return resolved;
  // External URL → proxy through our backend for html2canvas CORS access
  return `${BACKEND_URL}/api/asset-proxy?url=${encodeURIComponent(resolved)}`;
};

export const Logo = ({ size = "md", logoUrl = "", proxied = false }) => {
  const sizeMap = {
    sm: { icon: 22, name: "text-base", sub: "text-[9px]" },
    md: { icon: 28, name: "text-lg", sub: "text-[10px]" },
    lg: { icon: 40, name: "text-2xl", sub: "text-xs" },
  };
  const s = sizeMap[size] || sizeMap.md;
  const src = proxied ? proxyAsset(logoUrl) : resolveLogoUrl(logoUrl);

  if (logoUrl) {
    return (
      <div className="flex items-center gap-3" data-testid="company-logo">
        <img
          src={src}
          alt="HEO IT Engineering"
          {...(proxied ? { crossOrigin: "anonymous" } : {})}
          className="object-contain"
          style={{ height: s.icon * 1.4, maxWidth: 160 }}
        />
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3" data-testid="company-logo">
      <div className="bg-primary text-primary-foreground p-1.5 rounded-sm shrink-0">
        <Hexagon size={s.icon} weight="fill" />
      </div>
      <div className="leading-tight">
        <div className={`font-display font-black tracking-tighter ${s.name}`}>
          HEO
        </div>
        <div className={`overline text-muted-foreground ${s.sub}`}>
          IT Engineering
        </div>
      </div>
    </div>
  );
};

export default Logo;
